import CalendarMonthView from '@/components/calendar/CalendarMonthView'
import CalendarDayView from '@/components/calendar/CalendarDayView'
import CalendarEdit from '@/components/calendar/CalendarEdit'
import CalendarCreate from '@/components/calendar/CalendarCreate'
import CalendarList from '@/components/calendar/CalendarList'
import ReminderList from '@/components/reminder/ReminderList'
import ReminderCreate from '@/components/reminder/ReminderCreate'

export default [
  {
    path: '/calendrier/mois',
    name: 'CalendarMonthView',
    component: CalendarMonthView,
    meta: {
      parentName: 'Home',
      requiresAuth: true,
      maxHeight: true,
      needProfile: ['admin', 'seller', 'operator', 'manager', 'sector_manager']
    }
  },
  {
    path: '/calendrier/jour',
    name: 'CalendarDayView',
    component: CalendarDayView,
    meta: {
      parentName: 'CalendarMonthView',
      requiresAuth: true,
      maxHeight: true,
      needProfile: ['admin', 'seller', 'operator', 'manager', 'sector_manager']
    }
  },
  {
    path: '/calendrier/:id/edition',
    name: 'CalendarEdit',
    component: CalendarEdit,
    meta: {
      parentName: 'CalendarList',
      requiresAuth: true,
      needProfile: ['admin', 'seller', 'operator', 'manager', 'sector_manager']
    }
  },
  {
    path: '/calendrier/creation',
    name: 'CalendarCreate',
    component: CalendarCreate,
    meta: {
      parentName: 'CalendarList',
      requiresAuth: true,
      needProfile: ['admin', 'seller', 'operator', 'manager', 'sector_manager']
    }
  },
  {
    path: '/calendrier',
    name: 'CalendarList',
    component: CalendarList,
    meta: {
      parentName: 'Home',
      requiresAuth: true,
      needProfile: ['admin', 'seller', 'operator', 'manager', 'sector_manager']
    }
  },
  {
    path: '/rappels',
    name: 'ReminderList',
    component: ReminderList,
    meta: {
      parentName: 'Home',
      requiresAuth: true,
      needProfile: ['admin', 'seller', 'operator', 'manager', 'sector_manager']
    }
  },
  {
    path: '/rappels/creation',
    name: 'ReminderCreate',
    component: ReminderCreate,
    meta: {
      parentName: 'ReminderList',
      requiresAuth: true,
      needProfile: ['admin', 'seller', 'operator', 'manager', 'sector_manager']
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/calendarRouter.js